import { render, staticRenderFns } from "./PatientsFormDocsPopup.vue?vue&type=template&id=32978828&"
import script from "./PatientsFormDocsPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormDocsPopup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormDocsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports